"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  'size': 'm',
  'theme': {},
  'aria-label': 'Loading'
};

/**
 * This component is used to display wait states
 */
var Spinner = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Spinner, _React$Component);
  function Spinner() {
    (0, _classCallCheck2["default"])(this, Spinner);
    return _callSuper(this, Spinner, arguments);
  }
  (0, _createClass2["default"])(Spinner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        size = _this$props.size,
        className = _this$props.className,
        testId = _this$props.testId,
        theme = _this$props.theme,
        ariaLabel = _this$props['aria-label'];
      var cssClasses = (0, _classnames["default"])(theme.spinner, /* theme CSS localized styles */
      className, /* user specified classNames */
      theme["".concat(size)]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        role: "status",
        "aria-label": ariaLabel,
        className: cssClasses,
        "data-test-id": testId,
        "data-anypoint-component": Spinner.displayName
      });
    }
  }]);
  return Spinner;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Spinner, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Spinner, "displayName", 'Spinner');
//# sourceMappingURL=Spinner.js.map